<div class="cae-page">
  <div class="cae-shell">
    <header class="cae-header">
      <div class="cae-heading">
        <h1>{{ translate.instant('customerAccountEntries.title') }}</h1>
        <p class="cae-sub">{{ translate.instant('customerAccountEntries.subtitle') }}</p>
      </div>
      <div class="cae-actions">
        <button type="button" class="btn-primary-action" (click)="openCreateForm()" [disabled]="!companyId">
          <i class="fa fa-plus"></i>
          <span>{{ translate.instant('customerAccountEntries.actions.newEntry') }}</span>
        </button>
        <button type="button" class="btn-refresh" (click)="loadEntries()" [disabled]="loading || !companyId">
          <i class="fa fa-refresh" [class.fa-spin]="loading"></i>
          <span>{{ translate.instant('customerAccountEntries.actions.refresh') }}</span>
        </button>
      </div>
    </header>

    <div class="alert alert-warning cae-alert" *ngIf="!companyId">
      <i class="fa fa-exclamation-triangle"></i>
      {{ translate.instant('customerAccountEntries.warnings.no_company') }}
    </div>

    <section class="toolbar-panel">
      <div class="toolbar-row">
        <div class="toolbar-field">
          <label>{{ translate.instant('customerAccountEntries.filters.company') }} *</label>
          <p-dropdown
            [options]="companyData"
            [(ngModel)]="companyId"
            optionLabel="label"
            optionValue="company_id"
            [placeholder]="translate.instant('customerAccountEntries.filters.selectCompany')"
            (onChange)="onCompanyChange()"
            styleClass="cae-dropdown"
            panelStyleClass="cae-dropdown-panel"
            [filter]="true"
            filterBy="label"
            [appendTo]="'body'"
            [autoZIndex]="true"
            [baseZIndex]="11000">
          </p-dropdown>
        </div>
        <div class="toolbar-field">
          <label>{{ translate.instant('customerAccountEntries.filters.customer') }}</label>
          <p-dropdown
            [options]="customersForFilter"
            [(ngModel)]="customerFilterId"
            optionLabel="label"
            optionValue="customer_id"
            [showClear]="true"
            [filter]="true"
            filterBy="label"
            [placeholder]="translate.instant('customerAccountEntries.filters.allCustomers')"
            (onChange)="onCustomerFilterChange()"
            styleClass="cae-dropdown"
            panelStyleClass="cae-dropdown-panel"
            [appendTo]="'body'"
            [disabled]="!companyId"
            [autoZIndex]="true"
            [baseZIndex]="11000">
          </p-dropdown>
        </div>
        <div class="toolbar-field toolbar-field--date">
          <label>{{ translate.instant('customerAccountEntries.filters.fromDate') }}</label>
          <p-calendar
            [(ngModel)]="fromDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showButtonBar]="true"
            [selectOtherMonths]="true"
            appendTo="body"
            styleClass="cae-calendar"
            (ngModelChange)="onDateChange()">
          </p-calendar>
        </div>
        <div class="toolbar-field toolbar-field--date">
          <label>{{ translate.instant('customerAccountEntries.filters.toDate') }}</label>
          <p-calendar
            [(ngModel)]="toDate"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [showButtonBar]="true"
            [selectOtherMonths]="true"
            appendTo="body"
            styleClass="cae-calendar"
            (ngModelChange)="onDateChange()">
          </p-calendar>
        </div>
      </div>
      <p class="date-error" *ngIf="dateRangeError">{{ dateRangeError }}</p>
    </section>

    <section class="table-section">
      <!-- Desktop / tablet table -->
      <div class="table-responsive d-none d-md-block">
        <table class="cae-table">
          <thead>
            <tr>
              <th class="col-num">#</th>
              <th>{{ translate.instant('customerAccountEntries.table.date') }}</th>
              <th>{{ translate.instant('customerAccountEntries.table.customer') }}</th>
              <th>{{ translate.instant('customerAccountEntries.table.type') }}</th>
              <th class="col-amount">{{ translate.instant('customerAccountEntries.table.debit') }}</th>
              <th class="col-amount">{{ translate.instant('customerAccountEntries.table.credit') }}</th>
              <th>{{ translate.instant('customerAccountEntries.table.currency') }}</th>
              <th>{{ translate.instant('customerAccountEntries.table.note') }}</th>
              <th class="col-actions">{{ translate.instant('customerAccountEntries.table.actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="loading && !entries.length">
              <td colspan="9" class="cae-state-cell">
                <i class="fa fa-spinner fa-spin"></i>
                {{ translate.instant('customerAccountEntries.loading') }}
              </td>
            </tr>
            <tr *ngIf="!loading && !entries.length">
              <td colspan="9" class="cae-state-cell cae-state-cell--empty">
                <i class="fa fa-inbox" aria-hidden="true"></i>
                {{ translate.instant('customerAccountEntries.table.empty') }}
              </td>
            </tr>
            <tr
              *ngFor="let entry of entries; let i = index"
              [class.entry-debit]="entry.entry_type === 'debit'"
              [class.entry-credit]="entry.entry_type === 'credit'">
              <td class="col-num">{{ i + 1 }}</td>
              <td class="col-date">{{ formatDisplayDate(entry.entry_date) }}</td>
              <td class="col-customer" [title]="entryCustomerName(entry)">{{ entryCustomerName(entry) }}</td>
              <td>
                <span
                  class="type-badge"
                  [class.type-debit]="entry.entry_type === 'debit'"
                  [class.type-credit]="entry.entry_type === 'credit'">
                  <i
                    class="fa"
                    [class.fa-arrow-up]="entry.entry_type === 'debit'"
                    [class.fa-arrow-down]="entry.entry_type === 'credit'"></i>
                  {{ entryTypeLabel(entry.entry_type) }}
                </span>
              </td>
              <td class="amount-debit col-amount">{{ debitDisplay(entry) }}</td>
              <td class="amount-credit col-amount">{{ creditDisplay(entry) }}</td>
              <td class="col-currency">{{ entry.currency || 'ILS' }}</td>
              <td class="note-cell" [title]="entry.note || ''">{{ entry.note || '—' }}</td>
              <td class="actions-cell">
                <button
                  type="button"
                  class="btn-icon"
                  (click)="openEditForm(entry)"
                  [title]="translate.instant('customerAccountEntries.actions.edit')">
                  <i class="fa fa-pencil"></i>
                </button>
                <button
                  type="button"
                  class="btn-icon btn-icon-danger"
                  (click)="confirmDelete(entry)"
                  [title]="translate.instant('customerAccountEntries.actions.delete')">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Mobile cards -->
      <div class="cae-cards d-md-none">
        <div class="cae-state-cell cae-state-cell--empty" *ngIf="loading && !entries.length">
          <i class="fa fa-spinner fa-spin"></i>
          {{ translate.instant('customerAccountEntries.loading') }}
        </div>
        <div class="cae-state-cell cae-state-cell--empty" *ngIf="!loading && !entries.length">
          <i class="fa fa-inbox" aria-hidden="true"></i>
          {{ translate.instant('customerAccountEntries.table.empty') }}
        </div>
        <article
          class="cae-card-item"
          *ngFor="let entry of entries"
          [class.entry-debit]="entry.entry_type === 'debit'"
          [class.entry-credit]="entry.entry_type === 'credit'">
          <div class="cae-card-top">
            <span
              class="type-badge"
              [class.type-debit]="entry.entry_type === 'debit'"
              [class.type-credit]="entry.entry_type === 'credit'">
              {{ entryTypeLabel(entry.entry_type) }}
            </span>
            <span class="cae-card-date">{{ formatDisplayDate(entry.entry_date) }}</span>
          </div>
          <div class="cae-card-name" [title]="entryCustomerName(entry)">{{ entryCustomerName(entry) }}</div>
          <div class="cae-card-amounts">
            <div>
              <span class="muted">{{ translate.instant('customerAccountEntries.table.debit') }}</span>
              <strong class="amount-debit">{{ debitDisplay(entry) }}</strong>
            </div>
            <div>
              <span class="muted">{{ translate.instant('customerAccountEntries.table.credit') }}</span>
              <strong class="amount-credit">{{ creditDisplay(entry) }}</strong>
            </div>
            <div>
              <span class="muted">{{ translate.instant('customerAccountEntries.table.currency') }}</span>
              <strong>{{ entry.currency || 'ILS' }}</strong>
            </div>
          </div>
          <p class="cae-card-note" *ngIf="entry.note">{{ entry.note }}</p>
          <div class="cae-card-actions">
            <button type="button" class="btn-icon" (click)="openEditForm(entry)">
              <i class="fa fa-pencil"></i>
              {{ translate.instant('customerAccountEntries.actions.edit') }}
            </button>
            <button type="button" class="btn-icon btn-icon-danger" (click)="confirmDelete(entry)">
              <i class="fa fa-trash"></i>
              {{ translate.instant('customerAccountEntries.actions.delete') }}
            </button>
          </div>
        </article>
      </div>
    </section>
  </div>
</div>

<p-dialog
  [(visible)]="formVisible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(560px, 96vw)' }"
  styleClass="cae-dialog"
  [header]="editingEntryId ? translate.instant('customerAccountEntries.form.editTitle') : translate.instant('customerAccountEntries.form.newTitle')"
  (onHide)="closeForm()">

  <form [formGroup]="entryForm" class="cae-form" (ngSubmit)="saveEntry()">
    <div class="form-grid">
      <div class="form-group">
        <label>{{ translate.instant('customerAccountEntries.filters.company') }} *</label>
        <p-dropdown
          formControlName="company_id"
          [options]="companyData"
          optionLabel="label"
          optionValue="company_id"
          [placeholder]="translate.instant('customerAccountEntries.filters.selectCompany')"
          (onChange)="onFormCompanyChange()"
          styleClass="cae-dropdown"
          panelStyleClass="cae-dropdown-panel"
          [filter]="true"
          filterBy="label"
          [appendTo]="'body'"
          [autoZIndex]="true"
          [baseZIndex]="12000">
        </p-dropdown>
      </div>

      <div class="form-group">
        <label>{{ translate.instant('customerAccountEntries.filters.customer') }} *</label>
        <p-dropdown
          formControlName="customer_id"
          [options]="customersForForm"
          optionLabel="label"
          optionValue="customer_id"
          [placeholder]="translate.instant('customerAccountEntries.filters.selectCustomer')"
          styleClass="cae-dropdown"
          panelStyleClass="cae-dropdown-panel"
          [appendTo]="'body'"
          [filter]="true"
          filterBy="label"
          [autoZIndex]="true"
          [baseZIndex]="12000">
        </p-dropdown>
      </div>

      <div class="form-group">
        <label>{{ translate.instant('customerAccountEntries.form.entryDate') }} *</label>
        <p-calendar
          formControlName="entry_date"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          [selectOtherMonths]="true"
          appendTo="body"
          styleClass="cae-calendar">
        </p-calendar>
      </div>

      <div class="form-group form-group--full">
        <label>{{ translate.instant('customerAccountEntries.form.entryType') }} *</label>
        <div class="entry-type-radios" role="radiogroup">
          <label class="radio-option" [class.is-selected]="entryForm.get('entry_type')?.value === 'debit'">
            <input type="radio" formControlName="entry_type" value="debit" />
            <span class="radio-copy">
              <strong>{{ translate.instant('customerAccountEntries.entryTypes.debitShort') }}</strong>
              <small>{{ translate.instant('customerAccountEntries.entryTypes.debitHint') }}</small>
            </span>
          </label>
          <label class="radio-option" [class.is-selected]="entryForm.get('entry_type')?.value === 'credit'">
            <input type="radio" formControlName="entry_type" value="credit" />
            <span class="radio-copy">
              <strong>{{ translate.instant('customerAccountEntries.entryTypes.creditShort') }}</strong>
              <small>{{ translate.instant('customerAccountEntries.entryTypes.creditHint') }}</small>
            </span>
          </label>
        </div>
      </div>

      <div class="form-group">
        <label>{{ translate.instant('customerAccountEntries.form.amount') }} *</label>
        <input
          type="number"
          class="form-control cae-input"
          formControlName="amount"
          min="0.01"
          step="0.01"
          inputmode="decimal"
          [placeholder]="translate.instant('customerAccountEntries.form.amountPlaceholder')" />
      </div>

      <div class="form-group">
        <label>{{ translate.instant('customerAccountEntries.form.currency') }}</label>
        <p-dropdown
          formControlName="currency"
          [options]="currencyOptions"
          optionLabel="label"
          optionValue="code"
          [placeholder]="'ILS'"
          [filter]="currencyOptions.length > 6"
          filterBy="label,code"
          styleClass="cae-dropdown"
          panelStyleClass="cae-dropdown-panel"
          [appendTo]="'body'"
          [autoZIndex]="true"
          [baseZIndex]="12000"
          [disabled]="currenciesLoading">
        </p-dropdown>
      </div>

      <div class="form-group form-group--full">
        <label>{{ translate.instant('customerAccountEntries.form.note') }}</label>
        <textarea
          class="form-control cae-input"
          formControlName="note"
          rows="3"
          maxlength="1000"
          [placeholder]="translate.instant('customerAccountEntries.form.notePlaceholder')"></textarea>
      </div>
    </div>

    <div class="form-actions">
      <button type="button" class="btn-cancel" (click)="closeForm()" [disabled]="saving">
        {{ translate.instant('customerAccountEntries.actions.cancel') }}
      </button>
      <button type="submit" class="btn-save" [disabled]="saving || entryForm.invalid">
        <i class="fa fa-spinner fa-spin" *ngIf="saving"></i>
        <i class="fa fa-check" *ngIf="!saving"></i>
        {{ translate.instant('customerAccountEntries.actions.save') }}
      </button>
    </div>
  </form>
</p-dialog>
